define('app/views/defaultAnalytics/spa',["underscore"], function (_) {
  return {
    spaClassEvents: function (spaLocationId, startDate, events) {
      gtag("event", "view_item_list", {
        item_list_id: "Spa-Class-" + spaLocationId + "-" + startDate,
        item_list_name: "Spa Class Events on Location" + spaLocationId,
        items: _.map(
          _.uniq(events, function (item) {
            return item.SpaClass.SpaItemId;
          }),
          function (item) {
            var spaClass = item.SpaClass;
            return {
              item_id: spaClass.SpaItemId,
              item_name: spaClass.SpaItemName,
              affiliation: app.localization.siteName,
              item_category: spaClass.ItemCategory,
              item_category2: spaClass.ItemSubcategory,
              location_id: spaLocationId,
              price: +spaClass.Price,
              quantity: 1,
            };
          }
        ),
      });
    },
    spaClassConfirm: function (spaClassesQueue, location, startDate) {
      if(spaClassesQueue && spaClassesQueue.length) {
        gtag("event", "select_item", {
          item_list_id: "Spa-Class-" + location + "-" + startDate,
          item_list_name: "Spa Class Events on Location" + location,
          items: _.map(
            _.uniq(spaClassesQueue || [], function (item) {
              return item.SpaItemId;
            }), function (item) {
              return{
                item_id: item.SpaItemId,
                item_name: item.ProgramName,
                affiliation: app.localization.siteName,
                item_category: item.ItemCategory,
                item_category2: item.ItemSubcategory,
                location_id: location,
                price: +item.Price,
                quantity: 1,
              }
            })
        });
      }
    },
    prepClassModalClick: function (calEvent, spaLocationId, startDate) {
      var selectedItem = calEvent.SpaClass;
      gtag("event", "select_item", {
        item_list_id: "Spa-Class-" + spaLocationId + "-" + startDate,
        item_list_name: "Spa Class Events on Location" + spaLocationId,
        items: [
          {
            item_id: selectedItem.SpaItemId,
            item_name: selectedItem.SpaItemName,
            affiliation: app.localization.siteName,
            item_category: selectedItem.ItemCategory,
            item_category2: selectedItem.ItemSubcategory,
            location_id: spaLocationId,
            price: +selectedItem.Price,
            quantity: 1,
          },
        ],
      });

      gtag("event", "view_item", {
        currency: app.customization.currencyCode,
        value: +selectedItem.Price,
        items: [
          {
            item_id: selectedItem.SpaItemId,
            item_name: selectedItem.SpaItemName,
            affiliation: app.localization.siteName,
            item_category: selectedItem.ItemCategory,
            item_category2: selectedItem.ItemSubcategory,
            location_id: spaLocationId,
            price: +selectedItem.Price,
            quantity: 1,
          },
        ],
      });
    },
    serviceClick: function (serviceItem) {
      if (service) {
        gtag("event", "select_item", {
          item_list_id: "Spa-Service-" + locationId,
          item_list_name: "Spa Services on Location" + locationId,
          items: [
            {
              item_id: serviceItem.SpaItemId,
              item_name: serviceItem.ItemName,
              affiliation: app.localization.siteName,
              item_category: serviceItem.ItemCategory,
              item_category2: serviceItem.ItemSubcategory,
              location_id: serviceItem.LocationId,
              price: +serviceItem.Price,
              quantity: 1,
            },
          ],
        });
      }
    },
    serviceHeaderClick: function (serviceItem) {
      gtag("event", "view_item", {
        currency: app.customization.currencyCode,
        value: +serviceItem.Price,
        items: [
          {
            item_id: serviceItem.SpaItemId,
            item_name: serviceItem.ItemName,
            affiliation: app.localization.siteName,
            item_category: serviceItem.ItemCategory,
            item_category2: serviceItem.ItemSubcategory,
            location_id: serviceItem.LocationId,
            price: +serviceItem.Price,
            quantity: 1,
          },
        ],
      });
    },
    setActiveCategory: function (category, services) {
      console.log(category, services);
      if (services && services[category] && services[category].length) {
        var servicesList = services[category];
        var locationId = servicesList[0].LocationId;
        gtag("event", "view_item_list", {
          item_list_id: "Spa-Service-" + locationId,
          item_list_name: "Spa Services on Location" + locationId,
          items: _.map(servicesList, function (serviceItem) {
            return {
              item_id: serviceItem.SpaItemId,
              item_name: serviceItem.ItemName,
              affiliation: app.localization.siteName,
              item_category: serviceItem.ItemCategory,
              item_category2: serviceItem.ItemSubcategory,
              location_id: serviceItem.LocationId,
              price: +serviceItem.Price,
              quantity: 1,
            };
          }),
        });
      }
    },
  };
});

